/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { Text, useColorMode } from "theme-ui";
import { getAllMasterData, getAllMasterDataForTable } from '../../store/actions/masterData.action';
import { getAllHighlighters, getAllProjectMasterData, getSowChecklist, getSowFields } from '../../store/actions/project.action';
import frontapp from "../assets/images/Icon/frontapp.svg";
import ProjectView from '../assets/images/Project.svg';
import StageView from '../assets/images/StageView.svg';
import TaskView from '../assets/images/TaskView.svg';
import DeliveriesIcon from '../assets/images/deliveries_icon.svg';
import team from '../assets/images/teamLogo2.svg';
import dropdownArrow from "../assets/images/arrow.svg";
import dropdownArrowUp from "../assets/images/arrow-up.svg";
import DashboardIcon from '../assets/images/category.svg';
import userAdmin from "../assets/images/user-lock.svg";
import needInfo from "../assets/images/Icon/infoicon.svg";
import menu from '../assets/images/menucollapse.svg';
import settings from '../assets/images/settings.svg';
import notifications from "../assets/images/notification.svg";

import Task from '../assets/images/task-square.svg';
import Topbar from './topbar';
import { RootState } from '../../../@types';
import { useSelector } from 'react-redux';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import { bucketUrl } from '../../utils/global';

export const allowedRolesForAdministration = ["Super Admin", "Project Worker", "Project Manager", "Region Admin"];
export const allowedRolesForArchitect = ["Super Admin", "Project Worker", "Project Manager"];

const masterDataRoutes = [
  '/architect',
  '/stages',
  '/task-sow',
  '/task-field',
  '/task-type',
  '/blueprints',
  '/statuses',
  '/trading-rating',
  '/rating-criteria',
  '/allocated-hours'
];
const settingsRoutes = [
  '/user',
  '/client',
  '/role',
];

const dashboardRoutes = [
  '/dashboard',
  '/real-time-workload',
  '/worker-performance'
];

const Sidebar: React.FC = () => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [showMasterDataDropdown, setShowMasterDataDropdown] = useState(false);
  const [showSettingsDropdown, setShowSettingsDropdown] = useState(false);
  const [showTeamsDropdown, setShowTeamsDropdown] = useState(false);
  const [showTodosDropdown, setShowTodosDropdown] = useState(false);
  const [showViewsDropdown, setShowViewsDropdown] = useState(false);
  const [showReportDropdown, setShowReportDropdown] = useState(false);
  const [showGamificationDropdown, setshowGamificationDropdown] = useState(false);
  const [showDashboardDropdown, setShowDashboardDropdown] = useState(false);
  const [showStagesDropdown, setShowStagesDropdown] = useState(false);
  const [showReviewDropdown, setShowReviewDropdown] = useState(false);
  const [showDeliveriesDropdown, setShowDeliveriesDropdown] = useState(false);

  const [showFrontAppReportDropdown, setShowFrontAppReportDropdown] = useState(false);
  const { auther } = useSelector((state: RootState) => state.auth);
  const [colorMode] = useColorMode();
  const navbarBackground = colorMode === 'light' ? '#ffffff' : '#20283c';
  const label = colorMode === 'light' ? '#8d8d8d' : '#d4d9e5';
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setCollapsed(true);
      } else if (window.innerWidth <= 1024) {
        setCollapsed(true);
      } else {
        setCollapsed(false)
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);

    if (masterDataRoutes.some(route => location.pathname.startsWith(route))) {
      setShowMasterDataDropdown(true);
    } else {
      setShowMasterDataDropdown(false);
    }
    if (settingsRoutes.some(route => location.pathname.startsWith(route))) {
      setShowSettingsDropdown(true);
    } else {
      setShowSettingsDropdown(false);
    }
    if (dashboardRoutes.some(route => location.pathname.startsWith(route))) {
      setShowDashboardDropdown(true);
    } else {
      setShowDashboardDropdown(false);
    }
    if (location.pathname === '/stage-view-two') {
      setShowStagesDropdown(true);
    } else {
      setShowStagesDropdown(false);
      if (location.pathname.startsWith('/my-review') || location.pathname.startsWith('/worker-performance')) {
        setShowReviewDropdown(true);
      } else {
        setShowReviewDropdown(false);
      }
      if (location.pathname.startsWith('/deliveries')) {
        setShowDeliveriesDropdown(true);
      } else {
        setShowDeliveriesDropdown(false);
      }
    }

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [location.pathname]);

  useEffect(() => {

    if (![...masterDataRoutes, ...settingsRoutes, ...dashboardRoutes, '/my-review', '/worker-performance'].some(route => location.pathname.startsWith(route))) {
      setShowMasterDataDropdown(false);
      setShowSettingsDropdown(false);
      setShowDashboardDropdown(false);
      setShowReviewDropdown(false);
    }

  }, [location]);

  const handleToggle = () => {
    setCollapsed(!collapsed);
    setShowMasterDataDropdown(false);
    setShowSettingsDropdown(false);
    setShowDashboardDropdown(false);
    setShowStagesDropdown(false);
  };

  const handleMasterDataDropdownToggle = () => {
    setShowMasterDataDropdown(!showMasterDataDropdown);
    setShowSettingsDropdown(false);
    setShowDashboardDropdown(false);
    setShowStagesDropdown(false);
    setCollapsed(false);

  };

  const handleTeamsDropdownToggle = () => {
    setShowTeamsDropdown(!showTeamsDropdown);
    setShowStagesDropdown(false);
    setCollapsed(false);
  };
  const handleViewsDropdownToggle = () => {
    setShowViewsDropdown(!showViewsDropdown);
    setShowStagesDropdown(false);
    setCollapsed(false);
  };
  const handleReportDropdownToggle = () => {
    setShowReportDropdown(!showReportDropdown);
    setShowStagesDropdown(false);
    setCollapsed(false);
  };
  const handleTodosDropdownToggle = () => {
    setShowTodosDropdown(!showTodosDropdown);
    setShowStagesDropdown(false);
    setCollapsed(false);
  };
  const handleGamificationDropdownToggle = () => {
    setshowGamificationDropdown(!showGamificationDropdown);
    setShowStagesDropdown(false);
    setCollapsed(false);
  };
  const handleSettingsDropdownToggle = () => {
    setShowSettingsDropdown(!showSettingsDropdown);
    setShowMasterDataDropdown(false);
    setShowDashboardDropdown(false);
    setShowStagesDropdown(false);
    setCollapsed(false);

  };
  const handleFrontAppReportDropdownToggle = () => {
    setShowFrontAppReportDropdown(!showFrontAppReportDropdown);
    setCollapsed(false);
  };
  const handleDashboardDropdownToggle = () => {
    setShowDashboardDropdown(!showDashboardDropdown);
    setShowMasterDataDropdown(false);
    setShowSettingsDropdown(false);
    setShowStagesDropdown(false);
    setCollapsed(false);
  };

  const handleStagesDropdownToggle = () => {
    setShowStagesDropdown(!showStagesDropdown);
    setShowReviewDropdown(false);
    setCollapsed(false);
  };

  const handleReviewDropdownToggle = () => {
    setShowReviewDropdown(!showReviewDropdown);
    setShowDashboardDropdown(false);
    setShowMasterDataDropdown(false);
    setShowSettingsDropdown(false);
    setCollapsed(false);
  };

  const handleDeliveriesDropdownToggle = () => {
    setShowDeliveriesDropdown(!showDeliveriesDropdown);
    setCollapsed(false);
  };

  const dispatch = useDispatch()
  const key = localStorage.getItem("key")
  useEffect(() => {
    dispatch(getAllMasterData({ query: `?key=${key}` }))
  }, [key])

  useEffect(() => {
    dispatch(getAllMasterDataForTable());
    dispatch(getAllProjectMasterData());
    dispatch(getSowChecklist());
    dispatch(getSowFields());
    dispatch(getAllHighlighters())
  }, [])

  const hasAllowedRole = auther?.Role?.some(r => allowedRolesForAdministration.includes(r.RoleName));
  const hasArchitectRole = auther?.Role?.some(r => allowedRolesForArchitect.includes(r.RoleName));
  const isSuperAdmin = auther?.Role?.some(r => r?.RoleName === "Super Admin");
  const isRegionAdmin = auther?.Role?.some(r => r?.RoleName === "Region Admin");
  const isAllowedReport = !auther?.Role?.some(
    r => r?.RoleName === "Super Admin" || r?.RoleName === "Region Admin"
  );
  const isAllowedDeliveries = auther?.Role?.some(
    r => r?.RoleName === "Super Admin" || r?.RoleName === "Project Manager"
  );


  return (
    <>
      <Topbar collapsed={collapsed} />
      <nav className={`navbar-primary ${collapsed ? 'collapsed' : ''}`} style={{ backgroundColor: navbarBackground }}>
        <div className="d-flex btn-expand-collapse ps-3" >
          <img src={bucketUrl + 'PEC_transparent_full_logo.png'} alt="logo" className="logocoll" style={{ width: '160px', height: '80px' }} />
          <div className="menu-toggle-btn" onClick={handleToggle}>
            <img src={menu} alt="menu" width="35px" />
          </div>
        </div>
        <ul className="navbar-primary-menu">
          {/* <li className={`DashboardSide ${location.pathname === '/dashboard' ? 'active' : ''}`}>
            <Link to="/dashboard" className="DashboardSide">
              <img src={DashboardIcon} alt="Dashboard Icon" />
              <span className="nav-label" style={{ color: label }}>Dashboard</span>
            </Link>
          </li> */}
          <li style={{ cursor: "pointer" }}>
            <a className='DashboardSide' onClick={handleDashboardDropdownToggle}>
              <img src={DashboardIcon} alt="Dashboard Icon" />
              <span className="nav-label" style={{ color: label }}>Dashboard</span>
              {!collapsed && (
                colorMode === 'light' ? (
                  <img
                    className='mt-2 text-end'
                    src={showDashboardDropdown ? dropdownArrowUp : dropdownArrow}
                    alt="dropdown arrow"
                  />
                ) : (
                  showDashboardDropdown ? (
                    <FaAngleUp style={{ color: 'white' }} className="mt-2 text-end" />
                  ) : (
                    <FaAngleDown style={{ color: 'white' }} className="mt-2 text-end" />
                  )
                )
              )}               </a>
            {showDashboardDropdown && (
              <ul className="submenu" style={{ display: "grid", gap: "5px" }}>
                <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/dashboard' ? 'active' : ''}`} style={{ width: "auto" }}>
                  <Link to="/dashboard" className='w-100'>
                    <Text variant='Poppins14Normal' sx={{ color: label }}>Dashboard</Text>
                  </Link>
                </Text>
                <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/real-time-workload' ? 'active' : ''}`} style={{ width: "auto" }}>
                  <Link to="/real-time-workload" className='w-100'>
                    <Text variant='Poppins14Normal' sx={{ color: label }}>Real time - workload</Text>
                  </Link>
                </Text>
              </ul>
            )}
          </li>

          {/* {(isSuperAdmin) &&
            <li className={`DashboardSide`}>
              <Link to="/dashboard-new" className="DashboardSide">
                <img src={DashboardIcon} alt="Dashboard Icon" />
                <span className="nav-label" style={{ color: label }}> Dashboard(V2)</span>
                <img src={userAdmin} style={{ width: '20px', height: '20px', cursor: 'pointer' }} alt="user" title="Admin Access"
                />
              </Link>
            </li>
          } */}
          <li className={`DashboardSide ${location.pathname === '/project-view' ? 'active' : ''}`}>
            <Link to="/project-view" className="DashboardSide">
              <img src={ProjectView} alt="Role Icon" />
              <span className="nav-label" style={{ color: label }}>Project view </span>
            </Link>
          </li>
          {/* <li className={`DashboardSide ${location.pathname === '/project-view-two' ? 'active' : ''}`}>
            <Link to="/project-view-two" className="DashboardSide">
              <img src={ProjectView} alt="Role Icon" />
              <span className="nav-label">Project view (V2)</span>
            </Link>
          </li> */}
          <li style={{ cursor: "pointer" }}>
            <a className='DashboardSide' onClick={handleStagesDropdownToggle}>
              <img src={StageView} alt="Stage Icon" />
              <span className="nav-label" style={{ color: label }}>Stages view</span>
              {!collapsed && (
                colorMode === 'light' ? (
                  <img
                    className='mt-2 text-end'
                    src={showStagesDropdown ? dropdownArrowUp : dropdownArrow}
                    alt="dropdown arrow"
                  />
                ) : (
                  showStagesDropdown ? (
                    <FaAngleUp style={{ color: 'white' }} className="mt-2 text-end" />
                  ) : (
                    <FaAngleDown style={{ color: 'white' }} className="mt-2 text-end" />
                  )
                )
              )}
            </a>
            {showStagesDropdown && (
              <ul className="submenu" style={{ display: "grid", gap: "5px" }}>
                <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.search.includes('isMEP=true') ? 'active' : ''}`} style={{ width: "auto" }}>
                  <Link to="/stage-view-two?isMEP=true" className='w-100'>
                    <Text variant='Poppins14Normal' sx={{ color: label }}>MEP </Text>
                  </Link>
                </Text>
                <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.search.includes('isStructural=true') ? 'active' : ''}`} style={{ width: "auto" }}>
                  <Link to="/stage-view-two?isStructural=true" className='w-100'>
                    <Text variant='Poppins14Normal' sx={{ color: label }}>Structural</Text>
                  </Link>
                </Text>
                <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.search.includes('isFireSprinkler=true') ? 'active' : ''}`} style={{ width: "auto" }}>
                  <Link to="/stage-view-two?isFireSprinkler=true" className='w-100'>
                    <Text variant='Poppins14Normal' sx={{ color: label }}>Fire-Sprinkler</Text>
                  </Link>
                </Text>
              </ul>
            )}
          </li>
          {/* <li className={`DashboardSide ${location.pathname === '/stages-view-second' ? 'active' : ''}`}>
            <Link to="/stages-view-second" className="DashboardSide">
              <img src={StageView} alt="Role Icon" />
              <span className="nav-label">Stages view (V2)</span>
            </Link>
          </li> */}
          <li className={`DashboardSide ${location.pathname === '/task-view' ? 'active' : ''}`}>
            <Link to="/task-view" className="DashboardSide">
              <img src={TaskView} alt="Role Icon" />
              <span className="nav-label" style={{ color: label }}>Task view </span>
            </Link>
          </li>
          <li className={`DashboardSide ${location.pathname === '/needinfo-view' ? 'active' : ''}`}>
            <Link to="/needinfo-view" className="DashboardSide">
              <img src={needInfo} alt="Role Icon" style={{ height: '20px', width: '20px' }} />
              <span className="nav-label" style={{ color: label }}>Need Info view </span>
            </Link>
          </li>
          <li style={{ cursor: "pointer" }}>
            <a className='DashboardSide' onClick={handleDeliveriesDropdownToggle}>
              <img src={DeliveriesIcon} alt="Deliveries Icon" />
              <span className="nav-label" style={{ color: label }}>Deliveries</span>
              {!collapsed && (
                colorMode === 'light' ? (
                  <img
                    className='mt-2 text-end'
                    src={showDeliveriesDropdown ? dropdownArrowUp : dropdownArrow}
                    alt="dropdown arrow"
                  />
                ) : (
                  showDeliveriesDropdown ? (
                    <FaAngleUp style={{ color: 'white' }} className="mt-2 text-end" />
                  ) : (
                    <FaAngleDown style={{ color: 'white' }} className="mt-2 text-end" />
                  )
                )
              )}
            </a>
            {showDeliveriesDropdown && (
              <ul className="submenu" style={{ display: "grid", gap: "5px" }}>
                <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/deliveries/ready-to-deliver' || location.pathname === '/deliveries' ? 'active' : ''}`} style={{ width: "auto" }}>
                  <Link to="/deliveries/ready-to-deliver" className='w-100'>
                    <Text variant='Poppins14Normal' sx={{ color: label }}>Ready to Deliver</Text>
                  </Link>
                </Text>
                <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/deliveries/completed-deliveries' ? 'active' : ''}`} style={{ width: "auto" }}>
                  <Link to="/deliveries/completed-deliveries" className='w-100'>
                    <Text variant='Poppins14Normal' sx={{ color: label }}>Completed Deliveries</Text>
                  </Link>
                </Text>
                <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/deliveries/manual-deliveries' ? 'active' : ''}`} style={{ width: "auto" }}>
                  <Link to="/deliveries/manual-deliveries" className='w-100'>
                    <Text variant='Poppins14Normal' sx={{ color: label }}>Manual Deliveries</Text>
                  </Link>
                </Text>
              </ul>
            )}
          </li>
          <li style={{ cursor: "pointer" }}>
            <a className='DashboardSide' onClick={handleViewsDropdownToggle}>
              <img src={ProjectView} alt="Teams Icon" />
              <span className="nav-label" style={{ color: label }}>Unfiltered View</span>
              {!collapsed && (
                colorMode === 'light' ? (
                  <img
                    className='mt-2 text-end'
                    src={showViewsDropdown ? dropdownArrowUp : dropdownArrow}
                    alt="dropdown arrow"
                  />
                ) : (
                  showViewsDropdown ? (
                    <FaAngleUp style={{ color: 'white' }} className="mt-2 text-end" />
                  ) : (
                    <FaAngleDown style={{ color: 'white' }} className="mt-2 text-end" />
                  )
                )
              )}
            </a>
            {showViewsDropdown && (
              <ul className="submenu" style={{ display: "grid", gap: "5px" }}>

                <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/project-view-two' ? 'active' : ''}`} style={{ width: "auto" }}>
                  <Link to="/project-view-two" className='w-100'>
                    <Text variant='Poppins14Normal' sx={{ color: label }}>Project View</Text>
                  </Link>
                </Text>

                <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/stages-view-second' ? 'active' : ''}`} style={{ width: "auto" }}>
                  <Link to="/stages-view-second" className='w-100'>
                    <Text variant='Poppins14Normal' sx={{ color: label }}>Stage View</Text>
                  </Link>
                </Text>

              </ul>
            )}
          </li>
          <li style={{ cursor: "pointer" }}>
            <a className='DashboardSide' onClick={handleReviewDropdownToggle}>
              <img src={TaskView} alt="Review Icon" />
              <span className="nav-label" style={{ color: label }}>My Review</span>
              {!collapsed && (
                colorMode === 'light' ? (
                  <img
                    className='mt-2 text-end'
                    src={showReviewDropdown ? dropdownArrowUp : dropdownArrow}
                    alt="dropdown arrow"
                  />
                ) : (
                  showReviewDropdown ? (
                    <FaAngleUp style={{ color: 'white' }} className="mt-2 text-end" />
                  ) : (
                    <FaAngleDown style={{ color: 'white' }} className="mt-2 text-end" />
                  )
                )
              )}
            </a>
            {showReviewDropdown && (
              <ul className="submenu" style={{ display: "grid", gap: "5px" }}>
                <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/my-review' ? 'active' : ''}`} style={{ width: "auto" }}>
                  <Link to="/my-review" className='w-100'>
                    <Text variant='Poppins14Normal' sx={{ color: label }}>Report History</Text>
                  </Link>
                </Text>
                <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/worker-performance' ? 'active' : ''}`} style={{ width: "auto" }}>
                  <Link to="/worker-performance" className='w-100'>
                    <Text variant='Poppins14Normal' sx={{ color: label }}>Worker Performance</Text>
                  </Link>
                </Text>
              </ul>
            )}
          </li>

          <li style={{ cursor: "pointer" }}>
            <a className='DashboardSide' onClick={handleFrontAppReportDropdownToggle}>
              <img src={frontapp} alt="Notification" />
              <span className="nav-label" style={{ color: label }}>Front App</span>
              {!collapsed && (
                colorMode === 'light' ? (
                  <img
                    className='mt-2 text-end'
                    src={showFrontAppReportDropdown ? dropdownArrowUp : dropdownArrow}
                    alt="dropdown arrow"
                  />
                ) : (
                  showFrontAppReportDropdown ? (
                    <FaAngleUp style={{ color: 'white' }} className="mt-2 text-end" />
                  ) : (
                    <FaAngleDown style={{ color: 'white' }} className="mt-2 text-end" />
                  )
                )
              )}
            </a>
            {showFrontAppReportDropdown && (
              <ul className="submenu" style={{ display: "grid", gap: "5px" }}>
                <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/front-app/pending-items' ? 'active' : ''}`} style={{ width: "auto" }}>
                  <Link to="/front-app/pending-items" className='w-100'>
                    <Text variant='Poppins14Normal' sx={{ color: label }}>Pending Items</Text>
                  </Link>
                </Text>
                <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/front-app/completed-items' ? 'active' : ''}`} style={{ width: "auto" }}>
                  <Link to="/front-app/completed-items" className='w-100'>
                    <Text variant='Poppins14Normal' sx={{ color: label }}>Completed Items</Text>
                  </Link>
                </Text>
              </ul>
            )}
          </li>
          <li className={`DashboardSide ${location.pathname === '/notification' ? 'active' : ''}`}>
            <Link to="/notification" className="DashboardSide">
              <img src={notifications} alt="Notification" />
              <span className="nav-label" style={{ color: label }}>Notifications</span>
            </Link>
          </li>
          <li style={{ cursor: "pointer" }}>
            <a className='DashboardSide' onClick={handleReportDropdownToggle}>
              <img src={TaskView} alt="Teams Icon" />
              <span className="nav-label" style={{ color: label }}>Report</span>

              {!collapsed && (
                colorMode === 'light' ? (
                  <img
                    className='mt-2 text-end'
                    src={showReportDropdown ? dropdownArrowUp : dropdownArrow}
                    alt="dropdown arrow"
                  />
                ) : (
                  showReportDropdown ? (
                    <FaAngleUp style={{ color: 'white' }} className="mt-2 text-end" />
                  ) : (
                    <FaAngleDown style={{ color: 'white' }} className="mt-2 text-end" />
                  )
                )
              )}            </a>
            {showReportDropdown && (
              <ul className="submenu" style={{ display: "grid", gap: "5px" }}>
                <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/my-report' ? 'active' : ''}`} style={{ width: "auto" }}>
                  <Link to="/my-report" className='w-100'>
                    <Text variant='Poppins14Normal' sx={{ color: label }}>My Report</Text>
                  </Link>
                </Text>
                {/* {isAllowedReport && ( */}
                <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/my-generalreport' ? 'active' : ''}`} style={{ width: "auto" }}>
                  <Link to="/my-generalreport" className='w-100'>
                    <Text variant='Poppins14Normal' sx={{ color: label }}>General Timer History</Text>
                  </Link>
                </Text>
                {/* )} */}
                {(isSuperAdmin || isRegionAdmin) &&
                  <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/admin-report' ? 'active' : ''}`} style={{ width: "auto" }}>
                    <Link to="/admin-report" className='w-100'>
                      <Text variant='Poppins14Normal' sx={{ color: label }}>Admin Report</Text>
                      <img src={userAdmin} style={{ width: '20px', height: '20px', marginLeft: '10px', cursor: 'pointer' }} alt="user" title="Admin Access"
                      />
                    </Link>
                  </Text>
                }
                {(isSuperAdmin || isRegionAdmin) &&
                  <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/generalTimer-report' ? 'active' : ''}`} style={{ width: "auto" }}>
                    <Link to="/generalTimer-report" className='w-100'>
                      <Text variant='Poppins14Normal' sx={{ color: label }}>General Timer Report</Text>
                      <img src={userAdmin} style={{ width: '20px', height: '20px', cursor: 'pointer' }} alt="user" title="Admin Access" />

                    </Link>
                  </Text>
                }

                {/* <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/my-general-report' ? 'active' : ''}`} style={{ width: "auto" }}>
                  <Link to="/my-general-report" className='w-100'>
                    <Text variant='Poppins14Normal'>My General Report</Text>
                  </Link>
                </Text> */}

              </ul>
            )}
          </li>

          {/* {isSuperAdmin &&
            <li className={`DashboardSide ${location.pathname === '/admin-report' ? 'active' : ''}`}>
              <Link to="/admin-report" className="DashboardSide">
                <img src={TaskView} alt="Role Icon" />
                <span className="nav-label">Report</span>
              </Link>
            </li>
          } */}
          <li style={{ cursor: "pointer" }}>
            <a className='DashboardSide' onClick={handleTeamsDropdownToggle}>
              <img src={team} style={{ width: '30px', height: '30px' }} alt="Teams Icon" />
              <span className="nav-label" style={{ color: label }}>Teams</span>
              {!collapsed && (
                colorMode === 'light' ? (
                  <img
                    className='mt-2 text-end'
                    src={showTeamsDropdown ? dropdownArrowUp : dropdownArrow}
                    alt="dropdown arrow"
                  />
                ) : (
                  showTeamsDropdown ? (
                    <FaAngleUp style={{ color: 'white' }} className="mt-2 text-end" />
                  ) : (
                    <FaAngleDown style={{ color: 'white' }} className="mt-2 text-end" />
                  )
                )
              )}             </a>
            {showTeamsDropdown && (
              <ul className="submenu" style={{ display: "grid", gap: "5px" }}>
                {(isSuperAdmin) &&
                  <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/teams' ? 'active' : ''}`} style={{ width: "auto" }}>
                    <Link to="/teams" className='w-100'>
                      <Text variant='Poppins14Normal' sx={{ color: label }}>All Teams</Text>
                      <img src={userAdmin} style={{ width: '20px', height: '20px', marginLeft: '10px', cursor: 'pointer' }} alt="user" title="Admin Access" />

                    </Link>
                  </Text>
                }
                <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/your-team' ? 'active' : ''}`} style={{ width: "auto" }}>
                  <Link to="/your-team" className='w-100'>
                    <Text variant='Poppins14Normal' sx={{ color: label }}>My Team</Text>
                  </Link>
                </Text>
                <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/assigned-team' ? 'active' : ''}`} style={{ width: "auto" }}>
                  <Link to="/assigned-team" className='w-100'>
                    <Text variant='Poppins14Normal' sx={{ color: label }}>Assigned Team</Text>
                  </Link>
                </Text>
              </ul>
            )}
          </li>
          <li style={{ cursor: "pointer" }}>
            <a className='DashboardSide' onClick={handleGamificationDropdownToggle}>
              <img src={frontapp} alt="Teams Icon" />
              <span className="nav-label" style={{ color: label }}>Gamification</span>
              {!collapsed && (
                colorMode === 'light' ? (
                  <img
                    className='mt-2 text-end'
                    src={showGamificationDropdown ? dropdownArrowUp : dropdownArrow}
                    alt="dropdown arrow"
                  />
                ) : (
                  showGamificationDropdown ? (
                    <FaAngleUp style={{ color: 'white' }} className="mt-2 text-end" />
                  ) : (
                    <FaAngleDown style={{ color: 'white' }} className="mt-2 text-end" />
                  )
                )
              )}               </a>
            {showGamificationDropdown && (
              <ul className="submenu" style={{ display: "grid", gap: "5px" }}>


                <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/badges-details' ? 'active' : ''}`} style={{ width: "auto" }}>
                  <Link to="/badges-details" className='w-100'>
                    <Text variant='Poppins14Normal' sx={{ color: label }}>My Badges</Text>
                  </Link>
                </Text>
                <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/my-badges' ? 'active' : ''}`} style={{ width: "auto" }}>
                  <Link to="/my-badges" className='w-100'>
                    <Text variant='Poppins14Normal' sx={{ color: label }}>My Badges History</Text>
                  </Link>
                </Text>
              </ul>
            )}
          </li>
          {/* <li className={`DashboardSide ${location.pathname === '/my-badges' ? 'active' : ''}`}>
            <Link to="/my-badges" className="DashboardSide">
              <img src={frontapp} alt="Notification" />
              <span className="nav-label">My Badges History</span>
            </Link>
          </li> */}

          <li style={{ cursor: "pointer" }}>
            <a className='DashboardSide' onClick={handleTodosDropdownToggle}>
              <img src={Task} alt="Teams Icon" />
              <span className="nav-label" style={{ color: label }}>Todo</span>
              {!collapsed && (
                colorMode === 'light' ? (
                  <img
                    className='mt-2 text-end'
                    src={showTodosDropdown ? dropdownArrowUp : dropdownArrow}
                    alt="dropdown arrow"
                  />
                ) : (
                  showTodosDropdown ? (
                    <FaAngleUp style={{ color: 'white' }} className="mt-2 text-end" />
                  ) : (
                    <FaAngleDown style={{ color: 'white' }} className="mt-2 text-end" />
                  )
                )
              )}
            </a>
            {showTodosDropdown && (
              <ul className="submenu" style={{ display: "grid", gap: "5px" }}>
                {(isSuperAdmin) &&
                  <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/todos' ? 'active' : ''}`} style={{ width: "auto" }}>
                    <Link to="/todos" className='w-100'>
                      <Text variant='Poppins14Normal' sx={{ color: label }}>All Todos</Text>
                      <img src={userAdmin} style={{ width: '20px', height: '20px', marginLeft: '10px', cursor: 'pointer' }} alt="user" title="Admin Access" />
                    </Link>
                  </Text>
                }
                <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/your-team' ? 'active' : ''}`} style={{ width: "auto" }}>
                  <Link to="/my-todo" className='w-100'>
                    <Text variant='Poppins14Normal' sx={{ color: label }}>Assigned By Me</Text>
                  </Link>
                </Text>
                <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/assigned-todo' ? 'active' : ''}`} style={{ width: "auto" }}>
                  <Link to="/assigned-todo" className='w-100'>
                    <Text variant='Poppins14Normal' sx={{ color: label }}>Assigned To Me</Text>
                  </Link>
                </Text>

                <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/completed-todos' ? 'active' : ''}`} style={{ width: "auto" }}>
                  <Link to="/completed-todos" className='w-100'>
                    <Text variant='Poppins14Normal' sx={{ color: label }}>Completed Todo</Text>
                  </Link>
                </Text>

              </ul>
            )}
          </li>
          {
            hasAllowedRole &&
            <>
              <li style={{ cursor: "pointer" }}>
                <a className='DashboardSide' onClick={handleMasterDataDropdownToggle} >
                  <img src={Task} alt="Tasks" />
                  <span className="nav-label" style={{ color: label, whiteSpace: 'nowrap' }}>Master Data</span>
                  {!collapsed && (
                    colorMode === 'light' ? (
                      <img
                        className='mt-2 text-end'
                        src={showMasterDataDropdown ? dropdownArrowUp : dropdownArrow}
                        alt="dropdown arrow"
                      />
                    ) : (
                      showMasterDataDropdown ? (
                        <FaAngleUp style={{ color: 'white' }} className="mt-2 text-end" />
                      ) : (
                        <FaAngleDown style={{ color: 'white' }} className="mt-2 text-end" />
                      )
                    )
                  )}
                  {(isSuperAdmin) && (
                    <img
                      src={userAdmin}
                      style={{ width: '20px', height: '20px', marginLeft: '10px', cursor: 'pointer' }}
                      alt="user"
                      title='Admin Access'
                    />
                  )}
                </a>
                {showMasterDataDropdown && (
                  <ul className="submenu"
                    onClick={(event: any) => {
                      //setLey(event.target.textContent)
                      const value = event.target.textContent
                      localStorage.setItem('key', event.target.textContent);
                      //setLey(value)
                    }} style={{ display: "grid", gap: "5px" }}>
                    {hasArchitectRole && (
                      <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/architect' ? 'active' : ''}`} style={{ width: "auto" }}>
                        <Link to="/architect" className='w-100'>
                          <Text className='nav-label' sx={{ fontSize: '14px', color: label }}>
                            Architect
                          </Text>
                        </Link>
                      </Text>)}
                    {isSuperAdmin && (
                      <>
                        <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/stages' ? 'active' : ''}`} style={{ width: "auto" }}>

                          <Link to="/stages" className='w-100'>
                            <Text className='nav-label' sx={{ fontSize: '14px', color: label }}>
                              Stages
                            </Text>
                          </Link>

                        </Text>
                        <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/checklists' ? 'active' : ''}`} style={{ width: "auto" }}>

                          <Link to="/checklists" className='w-100'>
                            <Text className='nav-label' sx={{ fontSize: '14px', color: label }}>
                              Checklist
                            </Text>
                          </Link>

                        </Text>
                        <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/uploadTypes' ? 'active' : ''}`} style={{ width: "auto" }}>

                          <Link to="/uploadTypes" className='w-100'>
                            <Text className='nav-label' sx={{ fontSize: '14px', color: label }}>
                              Upload Type
                            </Text>
                          </Link>

                        </Text>
                        <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/allocated-hours' ? 'active' : ''}`} style={{ width: "auto" }}>

                          <Link to="/allocated-hours" className='w-100'>
                            <Text className='nav-label' sx={{ fontSize: '14px', color: label }}>
                              Allocated Hours
                            </Text>
                          </Link>

                        </Text>
                        <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/rating-criteria' ? 'active' : ''}`} style={{ width: "auto" }}>
                          <Link to="/rating-criteria" className='w-100'>
                            <Text className='nav-label' sx={{ fontSize: '14px', color: label }}>
                              Rating Criteria
                            </Text>
                          </Link>
                        </Text>
                        <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/trading-rating' ? 'active' : ''}`} style={{ width: "auto" }}>
                          <Link to="/trading-rating" className='w-100'>
                            <Text className='nav-label' sx={{ fontSize: '14px', color: label }}>
                              Trading Rating Criteria
                            </Text>
                          </Link>
                        </Text>
                        {/* <Text as={"li"} variant='Poppins14Normal'>
                                        <Link to="/project-type" className="DashboardSide">
                                            <Text variant='Poppins14Normal'>
                                                Project
                                            </Text>
                                        </Link>
                                    </Text> */}
                        <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/task-sow' ? 'active' : ''}`} style={{ width: "auto" }}>
                          <Link to="/task-sow" className='w-100'>
                            <Text className='nav-label' sx={{ fontSize: '14px', color: label }}>
                              Task Sow
                            </Text>
                          </Link>
                        </Text>
                        <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/task-field' ? 'active' : ''}`} style={{ width: "auto" }}>
                          <Link to="/task-field" className='w-100'>
                            <Text className='nav-label' sx={{ fontSize: '14px', color: label }}>
                              Task Fields Sow
                            </Text>
                          </Link>
                        </Text>
                        <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/task-type' ? 'active' : ''}`} style={{ width: "auto" }}>
                          <Link to="/task-type" className='w-100'>
                            <Text className='nav-label' sx={{ fontSize: '14px', color: label }}>
                              Task Type
                            </Text>
                          </Link>
                        </Text>

                        <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/blueprints' ? 'active' : ''}`} style={{ width: "auto" }}>
                          <Link to="/blueprints" className='w-100'>
                            <Text className='nav-label' sx={{ fontSize: '14px', color: label }}>
                              Blueprints
                            </Text>
                          </Link>
                        </Text>

                        <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/statuses' ? 'active' : ''}`} style={{ width: "auto" }}>
                          <Link to="/statuses" className='w-100'>
                            <Text className='nav-label' sx={{ fontSize: '14px', color: label }}>
                              Statuses
                            </Text>
                          </Link>
                        </Text>
                        <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/department-type' ? 'active' : ''}`} style={{ width: "auto" }}>
                          <Link to="/department-type" className='w-100'>
                            <Text variant='Poppins14Normal' sx={{ color: label }}>
                              Department Type
                            </Text>
                          </Link>
                        </Text>
                      </>
                    )}
                  </ul>
                )}
              </li>

            </>
          }

          {(isSuperAdmin) &&
            <li style={{ cursor: "pointer" }}>
              <a className='DashboardSide' onClick={handleSettingsDropdownToggle} >
                <img src={settings} alt="Tasks" />
                <span className="nav-label" style={{ color: label }}>Settings</span>
                {!collapsed && (
                  colorMode === 'light' ? (
                    <img
                      className='mt-2 text-end'
                      src={showSettingsDropdown ? dropdownArrowUp : dropdownArrow}
                      alt="dropdown arrow"
                    />
                  ) : (
                    showSettingsDropdown ? (
                      <FaAngleUp style={{ color: 'white' }} className="mt-2 text-end" />
                    ) : (
                      <FaAngleDown style={{ color: 'white' }} className="mt-2 text-end" />
                    )
                  )
                )}
                <img src={userAdmin} style={{ width: '20px', height: '20px', marginLeft: '10px', cursor: 'pointer' }} alt="user" title='Admin Access' />

              </a>
              {showSettingsDropdown && (
                <ul className="submenu" style={{ display: "grid", gap: "5px" }}>
                  {(isSuperAdmin) && (
                    <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/user' ? 'active' : ''}`} style={{ width: "auto" }}>
                      <Link to="/user" className='w-100'>
                        <Text className='nav-label' sx={{ fontSize: '14px', color: label }}>Users</Text>
                      </Link>
                    </Text>
                  )}
                  {(isSuperAdmin) && (
                    <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/client' ? 'active' : ''}`} style={{ width: "auto" }}>
                      <Link to="/client" className='w-100'>
                        <Text className='nav-label' sx={{ fontSize: '14px', color: label }}>Clients</Text>
                      </Link>
                    </Text>
                  )}
                  {isSuperAdmin &&
                    <Text as={"li"} variant='Poppins14Normal' className={`DashboardSide ${location.pathname === '/role' ? 'active' : ''}`} style={{ width: "auto" }}>
                      <Link to="/role" className='w-100'>
                        <Text className='nav-label' sx={{ fontSize: '14px', color: label }}>Role</Text>
                      </Link>
                    </Text>
                  }
                </ul>
              )}
            </li>

          }
          <span style={{ position: 'absolute', bottom: "10px", left: "20px" }}>{process.env.REACT_APP_ENV}</span>

        </ul>
      </nav>
    </>
  );
};

export default Sidebar;
